// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.106.2/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.106.2/node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.106.2/node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./system.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("./custom.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* overridden by src/lib/themes/guiHelpers.js */

/*
    Contains constants for the z-index values of elements that are part of the global stack context.
    In other words, z-index values that are "inside" a component are not added here.
    This prevents conflicts between identical z-index values in different components.
*/

/* Toolbox z-index: 40; set in scratch-blocks */

/* tooltips should go over add buttons if they overlap */

/* monitors go over add buttons */

/* "ask" block text input goes above monitors */

/* behind menu-bar */

/* Block drag z-index: 1000; default 50 is overriden in blocks.css */

/* so it is draggable into other panes */

/* behind modals */

/* behind modals */

/* in most interfaces, the context menu is always on top */

.fonts-modal_modal-content_fBz6q {
  max-width: 550px;
  margin-top: 50px;
}

.fonts-modal_body_snedx {
  background: var(--ui-modal-background);
  padding: 1.5rem 2.25rem;
  max-height: calc(100vh - 150px);
  overflow: auto;
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.fonts-modal_open-buttons_Ig8li {
  display: flex;
  gap: 1rem;
}

.fonts-modal_open-button_ZsPUG {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  width: 100%;
  align-items: center;
  background: none;
  padding: 0.5rem;
  margin: 0;
  border: 2px solid var(--ui-black-transparent);
  border-radius: 0.5rem;
}

.fonts-modal_open-button_ZsPUG:hover {
  color: var(--looks-secondary);
  border-color: var(--looks-secondary);
}

.fonts-modal_open-button-image_nNbEj {
  width: 64px;
  height: 64px;
  background-color: currentColor;
  -webkit-mask-size: cover;
          mask-size: cover;
  -webkit-mask-repeat: no-repeat;
          mask-repeat: no-repeat;
}

.fonts-modal_system-image_kJuTw {
  -webkit-mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
          mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}

.fonts-modal_custom-image_vJ0sI {
  -webkit-mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
          mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}

.fonts-modal_open-button-text_Z8jSY {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
}

.fonts-modal_open-button-text-main_pVdU8 {
  font-weight: bold;
}

.fonts-modal_open-button-text-sub_O6EE0 {
}

.fonts-modal_font-input-outer_sFzWh {
}

.fonts-modal_font-input_RuZfd {
  width: 100%;
  border: 1px solid var(--ui-black-transparent);
  border-radius: 0.25rem;
  padding: 0 1rem;
  height: 3rem;
  font: inherit;
  color: var(--text-primary);
  background-color: var(--input-background);
}

.fonts-modal_font-dropdown-outer_tNGrG {
  position: absolute;
  z-index: 510;
  background-color: var(--ui-white);
  color: var(--text-primary);
  border-radius: 0.25rem;
  overflow: auto;
  max-height: 300px;
  border: 1px solid var(--ui-black-transparent);
  box-sizing: border-box;
  box-shadow: 0px 0px 8px 1px var(--shadow);
}

.fonts-modal_font-dropdown-item_WpCxx {
  display: flex;
  align-items: center;
  padding: 0.5rem 0.75rem;
  height: 1.5rem;
  cursor: pointer;
  transition: 0.1s ease;
}

.fonts-modal_font-dropdown-item_WpCxx:hover {
  background-color: var(--looks-secondary);
  color: #ffffff;
}

.fonts-modal_font-playground_Xidh0 {
  background: none;
  border: none;
  padding: 0.5rem;
  margin: 0;
  resize: none;
  width: 100%;
  height: 100px;
  font-size: 1.5rem;
  border: 1px solid var(--ui-black-transparent);
  border-radius: 0.25rem;
}

.fonts-modal_button_i4rkh {
  font: inherit;
  font-weight: bold;
  padding: 0.75rem 1rem;
  border-radius: 0.25rem;
  border: 1px solid var(--ui-black-transparent);
  background-color: var(--looks-secondary);
  color: white;
}

.fonts-modal_button_i4rkh:disabled {
  opacity: 0.8;
}

.fonts-modal_fallback-container_l8PRW {
  display: flex;
  flex-direction: column;
}

.fonts-modal_fallback-label_ZZOPx {
  margin-bottom: 0.5rem;
}

.fonts-modal_fallback-list_Xp8ES {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  gap: 0.25rem;
}

.fonts-modal_fallback-button_FpfeE {
  background: none;
  padding: 0;
  border: 0;
  border-radius: 0.25rem;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.fonts-modal_fallback-button_FpfeE:hover {
  color: var(--looks-secondary);
}

.fonts-modal_fallback-container_l8PRW .fonts-modal_fallback-button-selected_CZxvk {
  background-color: var(--looks-secondary);
  color: white;
}

.fonts-modal_fonts-outer_dT05k {
  border-top: 2px solid var(--ui-black-transparent);
  padding-top: 1rem;
}

.fonts-modal_fonts-outer_dT05k p {
  margin-bottom: 0.5rem;
}

.fonts-modal_fonts_jYs5S {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.fonts-modal_manage-font_q0PZY {
  width: 100%;
  display: flex;
  align-items: center;
  border: 2px solid var(--ui-black-transparent);
  border-radius: 0.5rem;
  padding: 0.5rem;
  gap: 0.5rem;
}

.fonts-modal_manage-font-name_VIBD4 {
  font-size: 2rem;
  margin-bottom: 0.5rem;
  overflow-wrap: anywhere;
}

.fonts-modal_manage-font-buttons_VoUWV {
  margin-left: auto;
  flex-shrink: 0;
  display: flex;
  flex-direction: row;
  gap: 0.5rem;
}

.fonts-modal_manage-font-button_khoHl {
  background: none;
  border: none;
  border-radius: 100%;
  width: 2rem;
  height: 2rem;
  display: flex;
  align-items: center;
  justify-content: center;
}

.fonts-modal_manage-font-button_khoHl:hover {
  background-color: var(--ui-black-transparent);
}

.fonts-modal_manage-font-button_khoHl img {
  display: block;
  width: 100%;
  height: 100%;
  filter: var(--filter-icon-black);
}
`, "",{"version":3,"sources":["webpack://./src/components/tw-fonts-modal/fonts-modal.css"],"names":[],"mappings":"AAAA,+CAA+C;;AAE/C;;;;CAIC;;AAED,+CAA+C;;AAE/C,wDAAwD;;AAExD,iCAAiC;;AAEjC,+CAA+C;;AAE/C,oBAAoB;;AAEpB,oEAAoE;;AAEpE,wCAAwC;;AAExC,kBAAkB;;AAElB,kBAAkB;;AAElB,0DAA0D;;AAE1D;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,sCAAsC;EACtC,uBAAuB;EACvB,+BAA+B;EAC/B,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,WAAW;EACX,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,SAAS;EACT,6CAA6C;EAC7C,qBAAqB;AACvB;;AAEA;EACE,6BAA6B;EAC7B,oCAAoC;AACtC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,8BAA8B;EAC9B,wBAAwB;UAChB,gBAAgB;EACxB,8BAA8B;UACtB,sBAAsB;AAChC;;AAEA;EACE,2DAAqC;UAC7B,mDAA6B;AACvC;;AAEA;EACE,2DAAqC;UAC7B,mDAA6B;AACvC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,iBAAiB;AACnB;;AAEA;AACA;;AAEA;AACA;;AAEA;EACE,WAAW;EACX,6CAA6C;EAC7C,sBAAsB;EACtB,eAAe;EACf,YAAY;EACZ,aAAa;EACb,0BAA0B;EAC1B,yCAAyC;AAC3C;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,iCAAiC;EACjC,0BAA0B;EAC1B,sBAAsB;EACtB,cAAc;EACd,iBAAiB;EACjB,6CAA6C;EAC7C,sBAAsB;EACtB,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,wCAAwC;EACxC,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,SAAS;EACT,YAAY;EACZ,WAAW;EACX,aAAa;EACb,iBAAiB;EACjB,6CAA6C;EAC7C,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,qBAAqB;EACrB,sBAAsB;EACtB,6CAA6C;EAC7C,wCAAwC;EACxC,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,kCAAkC;EAClC,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;EACT,sBAAsB;EACtB,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,wCAAwC;EACxC,YAAY;AACd;;AAEA;EACE,iDAAiD;EACjD,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,6CAA6C;EAC7C,qBAAqB;EACrB,eAAe;EACf,WAAW;AACb;;AAEA;EACE,eAAe;EACf,qBAAqB;EACrB,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,6CAA6C;AAC/C;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,gCAAgC;AAClC","sourcesContent":["/* overridden by src/lib/themes/guiHelpers.js */\n\n/*\n    Contains constants for the z-index values of elements that are part of the global stack context.\n    In other words, z-index values that are \"inside\" a component are not added here.\n    This prevents conflicts between identical z-index values in different components.\n*/\n\n/* Toolbox z-index: 40; set in scratch-blocks */\n\n/* tooltips should go over add buttons if they overlap */\n\n/* monitors go over add buttons */\n\n/* \"ask\" block text input goes above monitors */\n\n/* behind menu-bar */\n\n/* Block drag z-index: 1000; default 50 is overriden in blocks.css */\n\n/* so it is draggable into other panes */\n\n/* behind modals */\n\n/* behind modals */\n\n/* in most interfaces, the context menu is always on top */\n\n.modal-content {\n  max-width: 550px;\n  margin-top: 50px;\n}\n\n.body {\n  background: var(--ui-modal-background);\n  padding: 1.5rem 2.25rem;\n  max-height: calc(100vh - 150px);\n  overflow: auto;\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n}\n\n.open-buttons {\n  display: flex;\n  gap: 1rem;\n}\n\n.open-button {\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n  width: 100%;\n  align-items: center;\n  background: none;\n  padding: 0.5rem;\n  margin: 0;\n  border: 2px solid var(--ui-black-transparent);\n  border-radius: 0.5rem;\n}\n\n.open-button:hover {\n  color: var(--looks-secondary);\n  border-color: var(--looks-secondary);\n}\n\n.open-button-image {\n  width: 64px;\n  height: 64px;\n  background-color: currentColor;\n  -webkit-mask-size: cover;\n          mask-size: cover;\n  -webkit-mask-repeat: no-repeat;\n          mask-repeat: no-repeat;\n}\n\n.system-image {\n  -webkit-mask-image: url(./system.svg);\n          mask-image: url(./system.svg);\n}\n\n.custom-image {\n  -webkit-mask-image: url(./custom.svg);\n          mask-image: url(./custom.svg);\n}\n\n.open-button-text {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n}\n\n.open-button-text-main {\n  font-weight: bold;\n}\n\n.open-button-text-sub {\n}\n\n.font-input-outer {\n}\n\n.font-input {\n  width: 100%;\n  border: 1px solid var(--ui-black-transparent);\n  border-radius: 0.25rem;\n  padding: 0 1rem;\n  height: 3rem;\n  font: inherit;\n  color: var(--text-primary);\n  background-color: var(--input-background);\n}\n\n.font-dropdown-outer {\n  position: absolute;\n  z-index: 510;\n  background-color: var(--ui-white);\n  color: var(--text-primary);\n  border-radius: 0.25rem;\n  overflow: auto;\n  max-height: 300px;\n  border: 1px solid var(--ui-black-transparent);\n  box-sizing: border-box;\n  box-shadow: 0px 0px 8px 1px var(--shadow);\n}\n\n.font-dropdown-item {\n  display: flex;\n  align-items: center;\n  padding: 0.5rem 0.75rem;\n  height: 1.5rem;\n  cursor: pointer;\n  transition: 0.1s ease;\n}\n\n.font-dropdown-item:hover {\n  background-color: var(--looks-secondary);\n  color: #ffffff;\n}\n\n.font-playground {\n  background: none;\n  border: none;\n  padding: 0.5rem;\n  margin: 0;\n  resize: none;\n  width: 100%;\n  height: 100px;\n  font-size: 1.5rem;\n  border: 1px solid var(--ui-black-transparent);\n  border-radius: 0.25rem;\n}\n\n.button {\n  font: inherit;\n  font-weight: bold;\n  padding: 0.75rem 1rem;\n  border-radius: 0.25rem;\n  border: 1px solid var(--ui-black-transparent);\n  background-color: var(--looks-secondary);\n  color: white;\n}\n\n.button:disabled {\n  opacity: 0.8;\n}\n\n.fallback-container {\n  display: flex;\n  flex-direction: column;\n}\n\n.fallback-label {\n  margin-bottom: 0.5rem;\n}\n\n.fallback-list {\n  display: grid;\n  grid-template-columns: 1fr 1fr 1fr;\n  gap: 0.25rem;\n}\n\n.fallback-button {\n  background: none;\n  padding: 0;\n  border: 0;\n  border-radius: 0.25rem;\n  height: 30px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.fallback-button:hover {\n  color: var(--looks-secondary);\n}\n\n.fallback-container .fallback-button-selected {\n  background-color: var(--looks-secondary);\n  color: white;\n}\n\n.fonts-outer {\n  border-top: 2px solid var(--ui-black-transparent);\n  padding-top: 1rem;\n}\n\n.fonts-outer p {\n  margin-bottom: 0.5rem;\n}\n\n.fonts {\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n}\n\n.manage-font {\n  width: 100%;\n  display: flex;\n  align-items: center;\n  border: 2px solid var(--ui-black-transparent);\n  border-radius: 0.5rem;\n  padding: 0.5rem;\n  gap: 0.5rem;\n}\n\n.manage-font-name {\n  font-size: 2rem;\n  margin-bottom: 0.5rem;\n  overflow-wrap: anywhere;\n}\n\n.manage-font-buttons {\n  margin-left: auto;\n  flex-shrink: 0;\n  display: flex;\n  flex-direction: row;\n  gap: 0.5rem;\n}\n\n.manage-font-button {\n  background: none;\n  border: none;\n  border-radius: 100%;\n  width: 2rem;\n  height: 2rem;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.manage-font-button:hover {\n  background-color: var(--ui-black-transparent);\n}\n\n.manage-font-button img {\n  display: block;\n  width: 100%;\n  height: 100%;\n  filter: var(--filter-icon-black);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"modal-content": `fonts-modal_modal-content_fBz6q`,
	"modalContent": `fonts-modal_modal-content_fBz6q`,
	"body": `fonts-modal_body_snedx`,
	"open-buttons": `fonts-modal_open-buttons_Ig8li`,
	"openButtons": `fonts-modal_open-buttons_Ig8li`,
	"open-button": `fonts-modal_open-button_ZsPUG`,
	"openButton": `fonts-modal_open-button_ZsPUG`,
	"open-button-image": `fonts-modal_open-button-image_nNbEj`,
	"openButtonImage": `fonts-modal_open-button-image_nNbEj`,
	"system-image": `fonts-modal_system-image_kJuTw`,
	"systemImage": `fonts-modal_system-image_kJuTw`,
	"custom-image": `fonts-modal_custom-image_vJ0sI`,
	"customImage": `fonts-modal_custom-image_vJ0sI`,
	"open-button-text": `fonts-modal_open-button-text_Z8jSY`,
	"openButtonText": `fonts-modal_open-button-text_Z8jSY`,
	"open-button-text-main": `fonts-modal_open-button-text-main_pVdU8`,
	"openButtonTextMain": `fonts-modal_open-button-text-main_pVdU8`,
	"open-button-text-sub": `fonts-modal_open-button-text-sub_O6EE0`,
	"openButtonTextSub": `fonts-modal_open-button-text-sub_O6EE0`,
	"font-input-outer": `fonts-modal_font-input-outer_sFzWh`,
	"fontInputOuter": `fonts-modal_font-input-outer_sFzWh`,
	"font-input": `fonts-modal_font-input_RuZfd`,
	"fontInput": `fonts-modal_font-input_RuZfd`,
	"font-dropdown-outer": `fonts-modal_font-dropdown-outer_tNGrG`,
	"fontDropdownOuter": `fonts-modal_font-dropdown-outer_tNGrG`,
	"font-dropdown-item": `fonts-modal_font-dropdown-item_WpCxx`,
	"fontDropdownItem": `fonts-modal_font-dropdown-item_WpCxx`,
	"font-playground": `fonts-modal_font-playground_Xidh0`,
	"fontPlayground": `fonts-modal_font-playground_Xidh0`,
	"button": `fonts-modal_button_i4rkh`,
	"fallback-container": `fonts-modal_fallback-container_l8PRW`,
	"fallbackContainer": `fonts-modal_fallback-container_l8PRW`,
	"fallback-label": `fonts-modal_fallback-label_ZZOPx`,
	"fallbackLabel": `fonts-modal_fallback-label_ZZOPx`,
	"fallback-list": `fonts-modal_fallback-list_Xp8ES`,
	"fallbackList": `fonts-modal_fallback-list_Xp8ES`,
	"fallback-button": `fonts-modal_fallback-button_FpfeE`,
	"fallbackButton": `fonts-modal_fallback-button_FpfeE`,
	"fallback-button-selected": `fonts-modal_fallback-button-selected_CZxvk`,
	"fallbackButtonSelected": `fonts-modal_fallback-button-selected_CZxvk`,
	"fonts-outer": `fonts-modal_fonts-outer_dT05k`,
	"fontsOuter": `fonts-modal_fonts-outer_dT05k`,
	"fonts": `fonts-modal_fonts_jYs5S`,
	"manage-font": `fonts-modal_manage-font_q0PZY`,
	"manageFont": `fonts-modal_manage-font_q0PZY`,
	"manage-font-name": `fonts-modal_manage-font-name_VIBD4`,
	"manageFontName": `fonts-modal_manage-font-name_VIBD4`,
	"manage-font-buttons": `fonts-modal_manage-font-buttons_VoUWV`,
	"manageFontButtons": `fonts-modal_manage-font-buttons_VoUWV`,
	"manage-font-button": `fonts-modal_manage-font-button_khoHl`,
	"manageFontButton": `fonts-modal_manage-font-button_khoHl`
};
export default ___CSS_LOADER_EXPORT___;
